/* jshint esversion: 6 */

/**
 * BridgesModule class provides a centralized way to access various bridge services.
 * It initializes and caches these services for efficient reuse.
 */
class BridgesModule {
    /**
     * Constructor for BridgesModule.
     * @param {Object} $rootScope - AngularJS root scope.
     * @param {Object} $injector - AngularJS injector service.
     */
    constructor($rootScope, $injector, DataBridgeService) {
        this.$rootScope = $rootScope;
        this.$injector = $injector;

        this.DataBridgeService = DataBridgeService;
        this.LogBridgeService = null;
        this.AuthenticationBridgeService = null;
        this.BridgeRuntimeService = null;
        this.EventLogBridgeService = null;

        this.isPreviewForSaveOps = this.$rootScope.isPreview;
        this.$rootScope.$watch('isPreview', (newVal, oldVal) => {
            if (this.isPreviewForSaveOps === true && newVal === false) {
                window.setTimeout(() => {
                    this.isPreviewForSaveOps = newVal;
                }, 700);
            } else {
                this.isPreviewForSaveOps = newVal;
            }
        });
    }

    /**
     * Returns the LogBridgeService instance.
     * If the service is not initialized, it initializes it and then returns.
     * @returns {Object} LogBridgeService instance.
     */
    logger() {
        if (this.LogBridgeService) {
            return this.LogBridgeService;
        }
        this.LogBridgeService = this.$injector.get('LogBridgeService');
        return this.LogBridgeService;
    }

    /**
     * Returns the EventLogBridgeService instance.
     * If the service is not initialized, it initializes it and then returns.
     * @returns {Object} EventLogBridgeService instance.
     */
    eventLog() {
        if (this.EventLogBridgeService) {
            return this.EventLogBridgeService;
        }
        this.EventLogBridgeService = this.$injector.get('EventLogBridgeService');
        return this.EventLogBridgeService;
    }

    /**
     * Returns the appropriate DataBridgeService instance based on the context.
     * If in preview mode, it returns the DataBridgeService.
     * If in CMS mode, it returns the CMSDataBridgeService.
     * Otherwise, it returns the DataBridgeService.
     * @returns {Object} DataBridgeService instance.
     */
    data() {
        return this.DataBridgeService;
    }

    /**
     * Returns the AuthenticationBridgeService instance.
     * If the service is not initialized, it initializes it and then returns.
     * @returns {Object} AuthenticationBridgeService instance.
     */
    authentication() {
        if (this.AuthenticationBridgeService) {
            return this.AuthenticationBridgeService;
        }
        this.AuthenticationBridgeService = this.$injector.get('AuthenticationBridgeService');
        return this.AuthenticationBridgeService;
    }

    /**
     * Returns the BridgeRuntimeService instance.
     * If the service is not initialized, it initializes it and then returns.
     * @returns {Object} BridgeRuntimeService instance.
     */
    runtime() {
        if (this.BridgeRuntimeService) {
            return this.BridgeRuntimeService;
        }
        this.BridgeRuntimeService = this.$injector.get('BridgeRuntimeService');
        return this.BridgeRuntimeService;
    }
}

BridgesModule.$inject = ['$rootScope', '$injector', 'DataBridgeService'];

export default BridgesModule;